/**
 * Модуль для инициализации и экспорта cadesplugin
 * Импортирует cadesplugin_api.js и экспортирует window.cadesplugin
 */
(window as any).cadesplugin_skip_extension_install = true;
(window as any).cadesplugin_load_timeout = 3000;

require('./cadesplugin_api.js');

if (window.cadesplugin && typeof window.cadesplugin.catch === 'function') {
    window.cadesplugin.catch((error: unknown) => {
        console.info('CryptoPro browser plugin is unavailable:', error);
    });
}

export const cadesplugin = window.cadesplugin;
